document.addEventListener("DOMContentLoaded", function () {
  // Sticky Header
  const header = document.querySelector('.site-header');
  
  const SCROLL_ENTER = 120;
  const SCROLL_EXIT = 20;
  
  let isScrolled = false;
  
  function updateHeaderClass() {
    const y = window.scrollY;
  
    if (!isScrolled && y > SCROLL_ENTER) {
      header.classList.add('scrolled');
      isScrolled = true;
    } else if (isScrolled && y < SCROLL_EXIT) {
      header.classList.remove('scrolled');
      isScrolled = false;
    }
  }
  
  window.addEventListener('scroll', updateHeaderClass, { passive: true });

  // Check on page load
  updateHeaderClass();

  // Check on scroll
  document.addEventListener("scroll", updateHeaderClass);
  
  
  // var for header height
const headerHeight = function () {
    const root = document.documentElement;
    const header = document.querySelector('.site-header');
    const adminBar = document.getElementById('wpadminbar');
    const mobileCta = document.querySelector('.mobile-header-cta');
  
    if (!header) return;
  
    function setHeaderHeight() {
      let height = header.offsetHeight;
  
      if (adminBar) {
        height += adminBar.offsetHeight;
      }
      
      if (mobileCta) {
        height -= mobileCta.getBoundingClientRect().height;
      }
      
      root.style.setProperty('--xds-header-height', `${height - 5}px`);
    }
  
    function debounce(fn, ms = 150) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
      };
    }
  
    const debouncedCalc = debounce(setHeaderHeight, 100);
  
    window.addEventListener('resize', debouncedCalc);
    window.addEventListener('scroll', debouncedCalc);
  
    setHeaderHeight();
  };
  
  headerHeight();

  
  // Debounced resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(headerHeight, 100);
  });

  // Mobile Menu
  document.querySelector(".hamburger").addEventListener("click", function () {
    document.body.classList.toggle("menu-active");
    this.classList.toggle("is-active");
  });

  document.querySelectorAll(".subnav .current-item, .subnav__icon").forEach(item => {
    item.addEventListener("click", function () {
      document.querySelector(".subnav nav").classList.toggle("expanded");
    });
  });

  const navLinks = document.querySelectorAll(".nav-link");
  const menu = document.querySelector(".main-menu-mobile"); 
  const menuToggle = document.querySelector(".navbar-toggler");
  const body = document.body;
  
  navLinks.forEach(link => {
    link.addEventListener("click", function () {
      const href = link.getAttribute("href") || "";
  
      // Only proceed if the href contains a '#'
      if (href.includes('#')) {
        menu.classList.remove("show");
        body.classList.remove("menu-active");
  
        if (menuToggle) {
          menuToggle.classList.remove("is-active");
        }
      }
    });
  });

  
  
});

